import { render, staticRenderFns } from "./candidateQrCode.vue?vue&type=template&id=9604d85a&"
import script from "./candidateQrCode.vue?vue&type=script&lang=js&"
export * from "./candidateQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports